import { Theme as ThemeMui, useMediaQuery as useMediaQueryMui }  from "@mui/material";

export interface UseMediaQueryOptions {
  defaultMatches?: boolean;
  matchMedia?: typeof window.matchMedia;
  noSsr?: boolean;
  ssrMatchMedia?: (query: string) => {
      matches: boolean;
  };
}

// Base it off of ThemeMui structure
export interface Theme {
  
}

export default function useMediaQuery(queryInput: string | ((theme: Theme) => string), options?: UseMediaQueryOptions): boolean {
  return useMediaQueryMui(queryInput, options);
}